import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
/**
 * @desc As Dialogs in InvestmentSpreadsheet are now managed as TemplateRef (to avoid displaying bug)
 * Using this service may be more convinient to handle values
 */
export class SpreadsheetDialogManagerService {
  // Use to send data to TemplateRef component
  _inputData: any = {};

  public get inputData(): any {
    return this._inputData;
  }

  public set inputData(data: any) {
    this._inputData = data;
  }

  constructor() { }

}
